// import {_initFlickityGraduatesMobile} from '../utilities/utilities-designsection';

export default class graduatesFilterMobile {
	constructor(textileList, filterForm, flickityGrad) {
		this.self = this;
		try {
			this._init(textileList, filterForm, this, flickityGrad);
		} catch {
			console.log('error in graduatesFilterMObile');
		}
	}

	getYearsToHide(yearsValue, item, dataItemsToHide) {
		if (yearsValue && yearsValue !== '') {
			let year = item.getAttribute('data-year-mobile');
			if (yearsValue !== year.toString()) {
				let id = item.getAttribute('data-id-mobile');
				dataItemsToHide.push(id);
			}
		}
	}

	getSearchedValueToHide(searchValue, item, dataItemsToHide) {
		let id = item.getAttribute('data-id-mobile');
		let searchedValue = item.getAttribute('data-search-mobile');
		if (searchValue) {
			if (searchValue.trim() !== '') {
				if (!searchedValue.toLowerCase().includes(searchValue.toLowerCase())) {
					dataItemsToHide.push(id);
				}
			}
		}
	}

	_init(textileList, filterForm, classElement, flickityGrad) {
		filterForm.addEventListener('change', function() {
			let dataItemsToHide = [];

			//Get chosen year
			let yearsDropdown = document.querySelector('#years-mob');
			let yearsValue = yearsDropdown.innerHTML;

			//Get searchstring
			let seaerchBarValue = document.querySelector(
				'#searchbar-graduates-mobile'
			).value;

			if (yearsValue === 'All years') {
				yearsValue = '';
			}

			//add the ids that should be shown to a list
			for (var itemTextile of textileList) {
				classElement.getYearsToHide(yearsValue, itemTextile, dataItemsToHide);
				classElement.getSearchedValueToHide(
					seaerchBarValue,
					itemTextile,
					dataItemsToHide
				);
			}
			//Loop through the list and set display none on the ids thats not in the list
			for (var itemToShowTextile of textileList) {
				if (
					dataItemsToHide.includes(
						itemToShowTextile.getAttribute('data-id-mobile')
					)
				) {
					itemToShowTextile.style.display = 'none';
				} else {
					itemToShowTextile.style.display = '';
				}
			}

			//reinit flickity after filter
			flickityGrad[0].resize();
			flickityGrad[1].resize();
		});
	}
}
